import "./App.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import "bootstrap/dist/css/bootstrap.min.css";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
// import PlansCard from "./components/PlansCard";
// import { Route, Routes } from "react-router-dom";
import { Pricing } from "./components/Pricing";
function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      {/* <PlansCard /> */}
      <Pricing />
      <Contact />
      <Footer />
      {/* <Routes>
        <Route Component={Pricing} path="/pricing" />
      </Routes> */}
    </div>
  );
}

export default App;
